<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsImage',
  
})
</script>
<template>
  <div class="tlbs-image">
    <img
      ref="imageDOM"
      :style="imageStyles"
      :src="src"
      draggable="false"
      @load="handleImgLoadCompleted"
      @error="handleImgLoadError"
    >
  </div>
</template>

<script setup lang="ts" name="TlbsImage">
interface Props {
  src: string;
  fit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
}

const props = withDefaults(defineProps<Props>(), {
  src: 'https://mapapi.qq.com/web/jsapi/assets/upload.png',
  fit: 'fill',
});

const emit = defineEmits<(e: 'load' | 'error') => void>();

// 图片自定义样式
const imageStyles = computed(() => ({
  objectFit: props.fit,
}));

// 图片加载完成回调
const handleImgLoadCompleted = () => {
  emit('load');
};
// 图片加载失败回调
const handleImgLoadError = () => {
  emit('error');
};
</script>
